import { IUser, User } from '@pozi/authmodule';

export class CompanyUser extends User {
  title?: string;
  lastName: string;
  firstName: string;
  companies: ICompany[];
  subcontractor?: ISubcontractor;

  constructor(raw: ICompanyUser) {
    super(raw);
    this.title = raw.title;
    this.lastName = raw.lastName;
    this.firstName = raw.firstName;
    this.companies = raw.companies;
    this.subcontractor = raw.subcontractor;
  }
}

export interface ICompanyUser extends IUser {
  title?: string;
  lastName: string;
  firstName: string;
  companies: ICompany[];
  subcontractor?: ISubcontractor;
}

export interface ICompany {
  name: string;
  id: number;
  sites: ISite[];
}

export interface ISite {
  name: string;
  id: number;
  default: boolean;
}

export interface ISubcontractor {
  id: number;
  name: string;
}
